import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';

// Cache-Buster: Bei jedem Render neue URL
const addCacheBuster = (path) => {
  if (!path) return path;
  const separator = path.includes('?') ? '&' : '?';
  return `${path}${separator}t=${Date.now()}`;
};

// Produkt-Konfiguration - PFADE HIER ÄNDERN
const PRODUCT_CONFIG = [
  { id: 1, path: '/images/mohrueben.jpg', titleKey: 'carrots' },
  { id: 2, path: '/images/rundpotatis.jpg', titleKey: 'potatoes' },
  { id: 3, path: '/images/kaal.webp', titleKey: 'whiteCabbage' },
  { id: 4, path: '/images/spetskal.jpg', titleKey: 'pointCabbage' },
  { id: 5, path: '/images/sauerkraut.jpg', titleKey: 'sauerkraut' },
  { id: 6, path: '/images/granskottserap.webp', titleKey: 'spruceSyrup' },
  { id: 7, path: '/images/vitrova.jpg', titleKey: 'whiteTurnip' },
  { id: 8, path: '/images/gulrova.jpg', titleKey: 'yellowTurnip' },
  { id: 9, path: '/images/kaalrot1.jpg', titleKey: 'rutabaga' },
  { id: 10, path: '/images/Het _odbetsgrillsaas.jpg', titleKey: 'grillSauce' },
  { id: 11, path: '/images/SM Tråån 16.jpg', titleKey: 'redBeetsString' },
  { id: 12, path: '/images/morotstraan.jpg', titleKey: 'carrotString' },
];
const ProductsPage = () => {
  const { t } = useLanguage();

  // Dynamisch bei jedem Render
  const products = PRODUCT_CONFIG.map(p => ({
    ...p,
    image: addCacheBuster(p.path),
    title: t(`products.items.${p.titleKey}`)
  }));

  return (
    <div className="min-h-screen bg-gray-50 py-16">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            {t('products.title')}
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {t('products.subtitle')}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((product) => (
            <div
              key={product.id}
              className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300"
            >
              <div className="h-64 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.title}
                  className="w-full h-full object-cover transform hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-800 mb-2">{product.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductsPage;